export default "__VITE_ASSET__f662ecba__"